import { render, staticRenderFns } from "./BackOffce.vue?vue&type=template&id=337e804a&scoped=true&"
import script from "./BackOffce.vue?vue&type=script&lang=js&"
export * from "./BackOffce.vue?vue&type=script&lang=js&"
import style0 from "./BackOffce.vue?vue&type=style&index=0&id=337e804a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337e804a",
  null
  
)

export default component.exports